
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCashierGrid extends Serenity.EntityGrid<PsCashierRow, any> {
        protected getColumnsKey() { return PsCashierColumns.columnsKey; }
        protected getDialogType() { return PsCashierDialog; }
        protected getIdProperty() { return PsCashierRow.idProperty; }
        protected getInsertPermission() { return PsCashierRow.insertPermission; }
        protected getLocalTextPrefix() { return PsCashierRow.localTextPrefix; }
        protected getService() { return PsCashierService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}